

import { ImageUploadPublic } from "./image.types";
import type { User } from "./user.types";
import type { Fulfillment } from "./fulfillment.types";

import { GetReviewsForLocationData } from '@dataconnect/account'
export type LocationReview =
  | GetReviewsForLocationData['reviewBy'][number]
  | GetReviewsForLocationData['reviewFor'][number];


export interface Review {
  id: string;
  fulfillment: {
    id: string;
    statusId: string;
    fulfillmentDate: number;
    fulfilledToLocationId: string;
    fulfilledByLocationId: string;
    order?: {
      id: string;
      orderItems_on_order: {
        id: string;
        listingVariation: {
          id: string;
          name: string;
          listing: {
            id: string;
            name: string;
          }
        }
      }[]
    }
  } | null
  reviewForId: string
  reviewById: string;
  isBuyer: boolean;
  rating: number;
  title: string;
  body: string;
  reviewImages_on_review: {
    sortOrder: number;
    image: ImageUploadPublic;
  }[]
  statusId: string;
  createdAt: Date;
  updatedAt: Date;
  updatedBy?: User
  updatedById?: string
}

export interface ReviewForEdit {
  id: string
  statusId: string
  fulfillment: {
    id: string;
    statusId: string;
    fulfilledToLocationId: string;
    fulfilledByLocationId: string;
  }
  reviewById: string
  reviewForId: string
  reviewImages_on_review: {
    sortOrder: number;
    image: ImageUploadPublic;
  }[]
  isBuyer: boolean
  title: string
  body: string
  rating: number
  updatedAt?: number
}

export const formatFulfillmentForReviewObject = (fulfillment: Fulfillment) => {
  return {
    id: fulfillment.id,
    statusId: fulfillment.statusId,
    fulfillmentDate: fulfillment.fulfillmentDate,
    fulfilledToLocationId: fulfillment.fulfilledToLocationId,
    fulfilledByLocationId: fulfillment.fulfilledByLocationId,
    fulfillmentNumber: fulfillment.fulfillmentNumber
  }
}

export const createBlankReview = (id: string, fulfillment: Pick<Fulfillment, 'id' | 'statusId' | 'fulfilledToLocationId' | 'fulfilledByLocationId'>, isBuyer: boolean = true): ReviewForEdit => {
  const f = {
    id: fulfillment.id,
    statusId: fulfillment.statusId,
    fulfilledToLocationId: fulfillment.fulfilledToLocationId,
    fulfilledByLocationId: fulfillment.fulfilledByLocationId
  }
  return {
    id: id,
    statusId: 'pending',
    fulfillment: f,
    reviewById: isBuyer ? fulfillment.fulfilledToLocationId || '' : fulfillment.fulfilledByLocationId || '',
    reviewForId: isBuyer ? fulfillment.fulfilledByLocationId || '' : fulfillment.fulfilledToLocationId || '',
    reviewImages_on_review: [],
    isBuyer: isBuyer,
    title: '',
    body: '',
    rating: 0,
    updatedAt: Date.now()
  }
}